import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PageResult } from '../interfaces/page-result';
import { ListagemProdutoComponent } from '../../views/relatorio/listagem-produto/listagem-produto.component';
import { ApuracaoResultados } from '../interfaces/apuracao-resultados';

@Injectable({
  providedIn: 'root'
})
export class ApuracaoResultadosService {

  readonly url = `${environment.apiURL}/relatorio/apuracao_resultados`;

  constructor(private http: HttpClient) { }

  saveOrUpdate(relatorio: ApuracaoResultados): Observable<ApuracaoResultados> {
    return this.http.put<ApuracaoResultados>(`${this.url}`, relatorio);
  }

  getItem(id: number ): Observable<ApuracaoResultados> {
    return this.http.get<ApuracaoResultados>(`${this.url}/${id}`);
  }

  getItemPage(page?: number, size?: number,
    order?: string, direction?: string): Observable<PageResult<ApuracaoResultados>> {
    return this.http.get<PageResult<ApuracaoResultados>>(`${this.url}/page/get/?page=${page}&size=`
     + `${size}&order=${order}&direction=${direction}`);
  }

  getItemPageSearch(page?: number, size?: number,  search?: string,
    order?: string, direction?: string): Observable<PageResult<ApuracaoResultados>> {
    return this.http.get<PageResult<ApuracaoResultados>>(`${this.url}/page/get/?page=${page}&size=` +
    `${size}&search=${search}&order=${order}&direction=${direction}`);
  }

  printForm(controle: number , formId: number, onlyPrint = false): Observable<any> {
    return this.http.get(`${this.url}/print/${controle}/${formId}/${onlyPrint}`, {responseType: 'arraybuffer'});
  }
}
